import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { applyTheme } from './lib/theme.js';
import './styles.css';

// Keeps the status-bar colour in step when "system" is chosen and the OS flips.
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => applyTheme());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// PWA (§3): installability is load-bearing — iOS web push in Phase 2 requires the
// app to be on the home screen, so the manifest and service worker ship on day one.
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {
        // An unregistered worker only costs offline caching; the app still works.
      });
    });
  } else {
    // In dev, Vite serves source modules at fixed URLs, and the worker's cache-first
    // asset rule would keep serving stale code forever. Built assets are hashed,
    // so this only bites in dev: make sure no worker is left over from a build.
    void navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => void r.unregister()));
  }
}
